
import { Component, Prop, Vue } from 'vue-property-decorator';
import DescriptionThirdApp from '~/components/User/Apps/DescriptionThirdApp.vue';
import { ApplicationEliot, CorporateEliot } from '~/interfaces/user.interface';
import ContentThirdApp from '~/components/User/Apps/ContentThirdApp.vue';

@Component({
    components: {
        DescriptionThirdApp,
        ContentThirdApp,
    },
})
export default class EliotApps extends Vue {
    @Prop({}) readonly apps?: CorporateEliot[] | ApplicationEliot[] ;
    @Prop() readonly title?: string;
}
